import React from "react";
import { useLottie } from "lottie-react";

const Animation = props => {
  const { file, loop = false, className = null, onClick = null } = props;
  const options = {
    animationData: file,
    loop: loop
  };
  const { View } = useLottie(options);
  return (
    <div onClick={onClick ? onClick : () => {}} className={className}>
      {View}
    </div>
  );
};

export default Animation;
